<template>
<div>
    <!-- 方案解析列表 -->
    <div v-show="!noData && solutions.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :offset="80"
        @load="onLoad"
      >
        <div class="list-content">
          <van-row class="list-item" v-for="(item, index) of solutions" :key="index">
            <router-link :to="`/news/detail/${item.columnId}.html?buildingType=${buildingType}&buildingTypeId=${buildingTypeId}&firstSysAttr=${firstSysAttr}&firstSysAttrId=${firstSysAttrId}`">
              <van-col :span="18">
                <van-row  class="list-item-title">
                  <div> {{item.columnTitle}}</div>
                </van-row>
                <van-row class="list-item-count">
                  <div> <span>{{item.pageView | myriabit}}</span>&nbsp;阅读量</div>
                </van-row>
              </van-col>
              <van-col :span="6" class="list-item-title"><img :src="item.matchPic | getImageUrl" alt=""></van-col>
            </router-link>
          </van-row>
        </div>
      </van-list>
    </div>
    <noResult v-show="noData && solutions.length <= 0" :noResultData="noResultData" @toListSelf="toListSelf"></noResult>
</div>
</template>

<script>
import { textSlice, myriabit, getImageUrl } from '@/filters/commonFilters'
import { getColumnList } from '@/api/news/news'
import noResult from '@/components/noResult'
export default {
  name: 'list',
  filters: {
    textSlice,
    myriabit,
    getImageUrl
  },
  components: { noResult },
  data () {
    return {
      loading: false,
      finished: false,
      paramsData: {
        pageNum: 1,
        pageSize: 10,
        tagName: '方案解析',
        brandId: '',
        buildingType: '',
        firstSysAttr: ''
      },
      solutions: [],
      noData: false,
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      },
      buildingType: '',
      buildingTypeId: '',
      firstSysAttr: '',
      firstSysAttrId: ''
    }
  },
  created () {
    this.$store.dispatch('BASE_DATA_GET_BRANDS')
    this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 5)
    this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 6)
    this.$store.dispatch('SOLUTIONS_GET_KEYWORD')
    // 建筑业态
    if (this.$route.query.buildingType) {
      this.paramsData['buildingType'] = this.$route.query.buildingTypeId
      this.buildingType = this.$route.query.buildingType
      this.buildingTypeId = this.$route.query.buildingTypeId
    }
    // 系统属性
    if (this.$route.query.firstSysAttr) {
      this.paramsData['firstSysAttr'] = this.$route.query.firstSysAttrId
      this.firstSysAttr = this.$route.query.firstSysAttr
      this.firstSysAttrId = this.$route.query.firstSysAttrId
    }
    this.getData()
  },
  methods: {
    // 方案详情
    jumpDetail (item) {
      this.$router.push(`/solutions/detail/${item.solutionId}.html`)
    },
    // 资讯详情
    toNewsDetail (id) {
      this.$router.push(`/news/detail/${id}.html`)
    },
    onLoad () {
      // 调用查询接口
      let self = this
      this.paramsData.pageNum++
      getColumnList(this.paramsData).then(result => {
        if (result && result.status === 200 && result.data && result.data.code === 200 && result.data.data && result.data.data.list && result.data.data.list.length > 0) {
          self.solutions = self.solutions.concat(result.data.data.list)
          self.paramsData.pageNum = result.data.data.pageNum
          window.setTimeout(() => {
            self.loading = false
            if (result.data.data.pageNum === result.data.data.pages) {
              self.finished = true
            }
          }, 1000)
        } else {
          self.loading = false
          self.finished = true
        }
      }).catch(() => {
        self.loading = false
        self.paramsData.total = 0
      })
    },
    getData () {
      if (!this.paramsData.firstSysAttr || this.paramsData.firstSysAttr === '') {
        delete this.paramsData.firstSysAttr
      }
      if (!this.paramsData.buildingType || this.paramsData.buildingType === '') {
        delete this.paramsData.buildingType
      }
      if (!delete this.paramsData.brandId || delete this.paramsData.brandId === '') {
        delete delete this.paramsData.brandId
      }
      this.paramsData.pageNum = 0
      this.paramsData.pageSize = 10
      this.finished = false
      this.noData = false
      this.onLoad()
    },
    toListSelf () {
      delete this.paramsData.firstSysAttr
      delete this.paramsData.buildingType
      delete this.paramsData.brandId
      this.getData()
    }
  }
}
</script>

<style scoped lang="scss">

  @mixin TwoLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
.list-content{
  background-color: white;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: 1px solid #D8D8D8;
  .list-item{
    border-bottom: 1px solid #D8D8D8;
    padding-top: 15px;
    &:last-child{
        border-bottom: none;
     }
    &-title{
      color: #222222;
      font-size: 14px;
      margin-bottom: 6px;
     img{
       width: 90px;
       height: 61px;
     }
      div{
        height: 40px;
        display: inline-block;
        max-width: 95%;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      & i{
          margin-left: 8px;
          border: 1px solid #1DBFDA;
          position: relative;
          font-size: 10px;
          padding: 0 5px;
          box-sizing: border-box;
          color: #1DBFDA;
          border-top-left-radius: 2px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          font-style: inherit;
          &::before{
             position: absolute;
             left: -5px;
             bottom: -1px;
             content: '';
             width:0;
             border-top:4px solid white;
             border-right:4px solid #1DBFDA;
           }
           &::after{
              position: absolute;
              left: -2px;
              bottom: 0px;
              content: '';
              width:0;
              border-top:2px solid transparent;
              border-right:2px solid white;
            }
        }
    }
     &-describe{
        color: #999999;
        font-size: 13px;
        height: 18px;
        line-height: 18px;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-count{
        margin-bottom: 15px;
        font-size: 10px;
        color: #a0a0a0;
        height: 14px;
        line-height: 14px;
        & span{
            color: #f8a325;
          }
       }
  }
}
.no-data-content{
  background-color: #f5f5f5;
  text-align: center;
  padding-top: 111px;
  .describe-content{
    p{
      font-size: 14px;
      color: #a0a0a0;
      margin: 0px;
    }
  }
  .button-content{
    button{
      margin-top: 40px;
      width: 200px;
      height: 44px;
      background-color: #1dbfda;
      color: white;
      border: none;
      border-radius: 5px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/solutionsList.vue